module.exports = __webpack_public_path__ + "static/img/4.4e9b494e.jpeg";